/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CalcResponse } from '../../models/calc-response';
import { CalculationModel } from '../../models/calculation-model';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface Calculations$Params {
  /**
   * Enabled markets - ISO 3166-1 alpha-2 country code of a market
   */
  market:
    | 'at'
    | 'au'
    | 'be'
    | 'ch'
    | 'cz'
    | 'de'
    | 'dk'
    | 'es'
    | 'fr'
    | 'gb'
    | 'hu'
    | 'in'
    | 'it'
    | 'jp'
    | 'kr'
    | 'lu'
    | 'mx'
    | 'my'
    | 'nl'
    | 'nz'
    | 'pl'
    | 'pt'
    | 'ro'
    | 'ru'
    | 'se'
    | 'sg'
    | 'sk'
    | 'th'
    | 'tr'
    | 'tw'
    | 'za';

  /**
   * 2 letter code ISO 639-1 for language followed by a hyphen and ISO 3166-1 ALPHA-2 of the country
   */
  'Accept-Language'?: string;

  /**
   * currently not used in V3, default values can be used
   */
  'User-Agent'?: string;

  /**
   * The rendering UI can send information on whether the customer has seen or changed the calculation. Used for measuring marketing acceptance.
   */
  'X-OCAPI-User-Interaction'?: string;

  /**
   * Unique identifier of the request. Makes it easier to trace behavior and trouble shooting.
   */
  'X-Request-ID'?: string;

  /**
   * Calculation context that needs to be used.
   */
  body: CalculationModel;
}

export function calculations(
  http: HttpClient,
  rootUrl: string,
  params: Calculations$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<CalcResponse>> {
  const rb = new RequestBuilder(rootUrl, calculations.PATH, 'post');
  if (params) {
    rb.path('market', params.market, {});
    rb.header('Accept-Language', params['Accept-Language'], {});
    rb.header('User-Agent', params['User-Agent'], {});
    rb.header('X-OCAPI-User-Interaction', params['X-OCAPI-User-Interaction'], {});
    rb.header('X-Request-ID', params['X-Request-ID'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalcResponse>;
    })
  );
}

calculations.PATH = '/{market}/calculations';
